import React from 'react'
import PropTypes from 'prop-types'
import { TextField, InputAdornment, IconButton, Typography, Box } from '@mui/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSearch, faTimes } from '@fortawesome/free-solid-svg-icons'
import { CircularProgress } from '@mui/material'
import styles from './SearchInput.module.scss'

const SearchInput = ({
  value = '',
  onChange,
  placeholder = 'Search...',
  count,
  loading = false,
  onClear,
  size = 'medium',
  fullWidth = false
}) => {
  const handleClear = () => {
    if (onClear) {
      onClear()
    } else if (onChange) {
      onChange({ target: { value: '' } })
    }
  }

  return (
    <Box className={`${styles.container} ${fullWidth ? styles.fullWidth : ''}`}>
      <TextField
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        variant='outlined'
        size={size === 'small' ? 'small' : 'medium'}
        fullWidth={fullWidth}
        className={styles.input}
        aria-label={placeholder}
        inputProps={{ 'aria-label': placeholder }}
        InputProps={{
          startAdornment: (
            <InputAdornment position='start'>
              {loading
                ? <CircularProgress size={16} className={styles.spinner} />
                : <FontAwesomeIcon icon={faSearch} className={styles.searchIcon} />}
            </InputAdornment>
          ),
          endAdornment: value ? (
            <InputAdornment position='end'>
              {count !== undefined && (
                <Typography variant='caption' className={styles.count}>
                  {count}
                </Typography>
              )}
              <IconButton size='small' onClick={handleClear} aria-label='Clear search'>
                <FontAwesomeIcon icon={faTimes} className={styles.clearIcon} />
              </IconButton>
            </InputAdornment>
          ) : null
        }}
      />
    </Box>
  )
}

SearchInput.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  count: PropTypes.number,
  loading: PropTypes.bool,
  onClear: PropTypes.func,
  size: PropTypes.oneOf(['small', 'medium']),
  fullWidth: PropTypes.bool
}

export default SearchInput
